// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { execute } from 'fg-frontend/src/partialUpdate';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  INPUT : '[data-fragment="NewsListing.input"]',
  LOAD_NEXT: '[data-fragment="NewsListing.loadNext"]',
  NEXT_WRAPPER: '[data-fragment="NewsListing.nextWrapper"]'
}

export default class NewsListing extends WebComponent {
  constructor (props) {
    super(props);

    this.state = {
      page: 1,
      hasNextPage: true
    }
  }

  didMount() {
    this.nextWrapperEl = this.element.querySelector(fragments.NEXT_WRAPPER)
    this.loadNextEl = this.element.querySelector(fragments.LOAD_NEXT)
    if (this.loadNextEl !== null) {
      this.loadNextEl.addEventListener("click", this.loadNext)
      const totalPages = this.loadNextEl.dataset.pagesCount
      this.setState({totalPages, hasNextPage: totalPages > this.state.page})
    }
  }

  loadNext = (e) => {
    const { page, totalPages } = this.state
    const nextPage = page + 1

    let params = '?'
    const inputs = [...document.querySelectorAll(fragments.INPUT)]
    inputs.map(i => {
      i.checked === true ? params += `${i.name.split(':')[1]}=${i.value}&` : null
    })
    params += `pageNumber=${nextPage}`

    const executeObject = {
      target: "dynamicPUContainer",
      alterHistory: false,
      url: `${this.props.url}${params}`,
      replaceTargetContent: (targetElement, newContentElement) => {
        const realTargetElement = targetElement.querySelector(`#${this.props.listingId}`)
        const realNewContentElement = newContentElement.querySelector(`#${this.props.listingId}`)
        const children = [...realNewContentElement.childNodes]
        children.map(c => realTargetElement.appendChild(c))
      },
      onBeforeContentsReplaced: () => {
        const hasNextPage = nextPage < totalPages
        classNames(this.nextWrapperEl, { 'd-none': !hasNextPage });
        this.setState({page: nextPage, hasNextPage: nextPage < totalPages})
      }
    }
    execute(executeObject);
  }
}



// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/components/NewsListing.js